const hero = document.querySelectorAll('.js-product-hero');

hero.forEach((elem) => {

  console.log(elem);

});

const mobileDetails = document.querySelectorAll('.js-mobile-details');

mobileDetails.forEach((details) => {

  const tl = gsap.timeline({ paused: true });
  tl.fromTo(details, { yPercent: 100 }, { yPercent: 0, ease: "power2.out", duration: .5 });

  // Define the matchMedia to handle screen size conditions
  const mm = gsap.matchMedia();

  // For devices up to 749px wide
  mm.add("(max-width: 749px)", () => {
    ScrollTrigger.create({
      trigger: '.js-product-hero',
      start: "bottom top", 
      onEnter: () => gsap.set(details, { visibility: "visible" }),
      onLeaveBack: () => gsap.set(details, { visibility: "hidden", delay: .5 }),
    });
  
    ScrollTrigger.create({
      trigger: '.js-product-hero',
      start: "bottom top", 
      onEnter: () => tl.play(),
      onLeaveBack: () => tl.reverse(),
      toggleActions: "play none none reverse"
    });
  
  });

});